import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import { tk } from './utils/styling/get-token';

export const GlobalStyles = createGlobalStyle<object>`
  ${normalize}

  * {
    box-sizing: border-box;

    &::before,
    &::after {
      box-sizing: border-box;
    }
  }

  button {
    background: none;
    border: none;
    color: inherit;
    padding: 0;

    &:not(:disabled) {
      cursor: pointer;
    }
  }

  button,
  [type="button"],
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: none;
    appearance: none;
  }

  select {
    -webkit-appearance: none;
    appearance: none;
  }

  a {
    color: ${tk('color_palette_grey_800')};
  }
  
  a:hover {
    color: ${tk('color_palette_primary_700')};
  }

  /**
   This is here to hide the favourites counter in the menu bar since it
   is not in sync with the favourites the user might check in the PLP and
   that might cause confusion.

   TODO: Remove after menu bar is migrated to react
   */
  .c-favorite-collector {
    padding-right: 0;

    &:after {
      content: none;
    }
  }
`;
